import React, { FC, useState, useCallback } from 'react';
import { OutsideFocusHandler } from '../dropdown/outside-handler/OutsideFocusHandler';

type Props = {
  children: (isOpen: boolean, toggle: Function) => React.ReactNode;
  className?: string;
};

export const CustomDropdown: FC<Props> = ({ children, className }) => {
  const [isOpen, toggle] = useState(false);

  const handleClickOutside = useCallback(() => {
    if (isOpen) {
      toggle(false);
    }
  }, [isOpen]);

  const toggleOnClick = () => {
    toggle((state) => !state);
  };

  return (
    <OutsideFocusHandler
      onOutsideClick={handleClickOutside}
      className={className}
    >
      {children(isOpen, toggleOnClick)}
    </OutsideFocusHandler>
  );
};
